import Banner from "../assets/banner.jpg"

export default function PageBanner({ title, breadcrumbs }) {
  return (
    <div
      className="page-banner position-relative d-flex flex-column justify-content-center align-items-start pt-5"
      style={{
        backgroundImage: `url('${Banner}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "50vh",
      }}
    >
      <div className="container py-5 mt-5">
        <h1 className="fw-bold text-start brand text-white">{title}</h1>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-start">
            {breadcrumbs.map((breadcrumb, index) => (
              <li
                key={index}
                className={`breadcrumb-item ${
                  breadcrumb.active ? "active text-white fw-bold" : ""
                }`}
                aria-current={breadcrumb.active ? "page" : undefined}
              >
                {breadcrumb.active ? (
                  breadcrumb.label
                ) : (
                  <a
                    href={breadcrumb.href}
                    className="text-light text-decoration-none fw-bold"
                  >
                    {breadcrumb.icon && (
                      <i className={`bi ${breadcrumb.icon} me-1`} style={{ color: "#00b0f7" }}></i>
                    )}
                    {breadcrumb.label}
                  </a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
}
